import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const UnauthorizedPage: React.FC = () => {
  return (
    <Layout
      title="Nicht autorisiert | Stimm.DEV"
      description="Sie haben keine Berechtigung für diese Seite. Bitte melden Sie sich an oder kontaktieren Sie uns."
      keywords="401, Nicht autorisiert, Anmeldung erforderlich"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #f39c12, #e67e22)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              401
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Nicht autorisiert
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Sie haben keine Berechtigung, diese Seite zu besuchen. 
              Möglicherweise müssen Sie sich anmelden oder haben keine 
              ausreichenden Zugriffsrechte.
            </p>

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <Link 
                to="/" 
                className="primary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
              
              <a 
                href="mailto:support@stimm.dev"
                className="secondary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-envelope" style={{ marginRight: '0.5rem' }}></i>
                Kontakt aufnehmen
              </a>
            </div>

            <div style={{ 
              padding: '2rem',
              background: 'var(--card-background)',
              borderRadius: '1rem',
              border: '1px solid var(--border-color)',
              textAlign: 'left'
            }}>
              <h3 style={{ marginBottom: '1rem', color: 'var(--text-color)' }}>
                <i className="fas fa-lock" style={{ marginRight: '0.5rem', color: 'var(--warning-color)' }}></i>
                Mögliche Ursachen:
              </h3>
              
              <ul style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.8',
                paddingLeft: '1.5rem'
              }}>
                <li>Sie sind nicht angemeldet</li>
                <li>Ihre Sitzung ist abgelaufen</li>
                <li>Sie haben keine Berechtigung für diesen Bereich</li>
                <li>Der Link ist veraltet oder ungültig</li>
              </ul>

              <div style={{ 
                marginTop: '2rem',
                padding: '1rem',
                background: 'var(--warning-color-light)',
                borderRadius: '0.5rem',
                borderLeft: '4px solid var(--warning-color)'
              }}>
                <strong style={{ color: 'var(--text-color)' }}>
                  <i className="fas fa-info-circle" style={{ marginRight: '0.5rem' }}></i>
                  Benötigen Sie Zugang?
                </strong>
                <p style={{ margin: '0.5rem 0 0 0', color: 'var(--text-muted)' }}>
                  Kontaktieren Sie uns für weitere Informationen zu Zugriffsberechtigungen 
                  oder besuchen Sie unsere{' '}
                  <Link 
                    to="/" 
                    style={{ color: 'var(--primary-color)', textDecoration: 'none' }}
                  >
                    Startseite
                  </Link>
                  {' '}für öffentlich zugängliche Inhalte.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default UnauthorizedPage;
